const style = {
  row: {
    border: `1px solid transparent`,
    borderBottom: `1px solid #666`
  },
  rowActive: {
    background: `#666`
  },
  header: {
    borderBottom: `1px solid #666`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/User/partials/GroupForm/style/ColorBlind/list.js